import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE } from './config'
import { resolveInitialLanguage } from './appLanguage'
import { namespaces, resources } from './resources'

i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: ['en', 'es'],
  defaultNS: 'common',
  ns: namespaces,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

document.documentElement.lang = i18n.language
document.documentElement.dir = 'ltr'

export default i18n
export * from './appLanguage'
export * from './config'
export { namespaces, resources } from './resources'
